import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiChevronDown } from 'react-icons/fi'; // Using react-icons library
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FiChevronUp } from 'react-icons/fi';
import { User } from 'react-feather'; // Import the User icon
import { ToastContainer, toast } from 'react-toastify';

const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#293495;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const Card = styled.div`
  box-shadow: 0px 5px 10px #00000038;
  background: #fff;
  border-radius: 10px;
  opacity: 1;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 200px;
`;

const DateContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-left: 20px;

`;

const DateInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

`;

const Label = styled.label`
  color: #3D46B4;
  margin-bottom: 5px;
`;

const Dropdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #3D46B4;
  padding: 10px;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  position: relative;
  background: transparent;
`;

const DropdownText = styled.span`
  color: ${({ hasSelection }) => (hasSelection ? '#000' : '#293495')};
  font-size: 16px;
`;

const DropdownIcon = styled(FiChevronDown)`
  color: #3D46B4;
`;

const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 5px); /* Positioning panel just below the dropdown */
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #3D46B4;
  border-radius: 4px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

const DropdownOption = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 20px;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  &:first-child {
    background-color: #FF4B4B;
    box-shadow: 0px 10px 20px #7E18182E;
  }
  &:last-child {
    background-color: #2B3497;
    box-shadow: 0px 10px 20px #2B349752;
  }
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;



const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

const TableBody = styled.tbody``;



const StyledDatePicker = styled(DatePicker)`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2B3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2B3497;
    }
  }`
const CompanyInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const CompanyInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const EmployeeNameInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const EmployeeNameInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const LocationInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const LocationInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const PassReturnInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;
const CustomInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;
const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
  cursor:pointer;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;
const StyledDropdown = styled.select`
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  background: #fff;
  outline: none; /* Remove default focus outline */
`;

const ExportIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  color: #28a745; /* Green color for Excel icon */
`;
const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // margin:14px 44px;
`;
const ProfileIcon = styled.div`
 width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;


const BlackListReportPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const dropdownRef = useRef(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [companyName, setCompanyName] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [locationName, setLocationName] = useState('');
  const [passReturn, setPassReturn] = useState('');
  const [visitorReports, setVisitorReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalItems, setTotalItems] = useState(0); // Define totalItems in the state

  const itemsPerPage = 10; // Number of items per page
  const [tableData, setTableData] = useState([]); // Initialize without dummy data
  const [searchQuery, setSearchQuery] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;
  const [locations, setLocations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  // Sort function
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  };

  const [formValues, setFormValues] = useState({
    employeeName: '',
    locationName: ''

  }

  );


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const locationsResponse = await axios.get('/Location');
        setLocations(locationsResponse.data);

        const employeesResponse = await axios.get('/employee');
        setEmployees(employeesResponse.data);

      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };

    fetchDropdownData();
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchVisitorTypeData = async () => {
    try {
      const payload = {

        id: 0,
        visitorName: null,
        visitorMobile: null,
        visitorCompany: null,
        host: null,
        blackList: true,
        reasonforBlackListing: null,
        visitDate: null


      }; // Add any required payload data here

      const response = await axios.post('/BlackList', payload, {
        headers: {
          'Content-Type': 'application/json', // Set appropriate content type if needed
        },
      });
      setTableData(response.data);
      setOriginalTableData(response.data);
    } catch (error) {
      console.error('Error fetching Visitor Report data:', error);
    }
  };

  useEffect(() => {
    fetchVisitorTypeData();
  }, []);
  const formatDate = (date) => {
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  };
  const formatDateToCustom = (date) => {
    const padZero = (number, length = 2) => String(number).padStart(length, '0');

    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());
    const milliseconds = padZero(date.getMilliseconds(), 7); // Pad milliseconds to 7 digits

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  };

  const [originalTableData, setOriginalTableData] = useState([]);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [filterInfo, setFilterInfo] = useState({ type: "", value: "" });

  const handleSearchData = () => {
    let filtered = [...originalTableData];

    switch (selectedOption) {
      case 'Date Wise':
        if (fromDate && toDate) {
          const from = new Date(fromDate);
          from.setHours(0, 0, 0, 0);

          const to = new Date(toDate);
          to.setHours(23, 59, 59, 999);

          filtered = filtered.filter(row => {
            const visitDate = new Date(row.visitDate.replace(" ", "T").split(".")[0]);
            return visitDate >= from && visitDate <= to;
          });
        }
        break;
      case 'Company Wise':
        if (companyName) {
          filtered = filtered.filter(row =>
            row.visitorCompany && row.visitorCompany.toLowerCase().includes(companyName.toLowerCase())
          );
        }
        break;
      default:
        break;
    }

    let type = "";
    let value = "";

    if (selectedOption === "Date Wise" && fromDate && toDate) {
      type = "Date Wise";
      value = `From ${new Date(fromDate).toLocaleDateString("en-GB")} To ${new Date(toDate).toLocaleDateString("en-GB")}`;
    } else if (selectedOption === "Company Wise" && companyName) {
      type = "Company Name";
      value = companyName;
    }

    setFilterInfo({ type, value });
    setIsSearchClicked(true);

    setTableData(filtered);
  };

  const normalize = (text) =>
    text
      ?.toString()
      .toLowerCase()
      .replace(/\|/g, " ")
      .replace(/\s+/g, " ")
      .trim() || "";

  const formatVisitDate = (date) => {
    if (!date) return "";
    return date.toString();
  };

  const search = normalize(searchQuery);

  const filteredData = tableData.filter((row) => {
    const visitDate = normalize(formatVisitDate(row.visitDate));
    const visitorName = normalize(row.visitorName);

    const nameWords = visitorName.split(" ");
    const searchWords = search.split(" ");

    const nameMatches = searchWords.every(sw =>
      nameWords.some(nw => nw.startsWith(sw))
    );

    return (
      row.id?.toString().includes(search) ||
      nameMatches ||
      normalize(row.nationality).includes(search) ||
      normalize(row.visitorCompany).includes(search) ||
      normalize(row.host).includes(search) ||
      normalize(row.meetingVenue).includes(search) ||
      normalize(row.visitorMobile).includes(search) ||
      visitDate.includes(search)
    );
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const formatDateTime = (dateTime) => {
    return dateTime.replace('T', ' ');
  };
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  // Function to toggle the export options panel
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export.');
      return;
    }
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpen(false);
  };
  const formatDateTimeForExcel = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} : ${hours}:${minutes}:${seconds}`;
  };
  const exportToExcel = () => {
    const filteredDataNee = filteredData.map((row) => ({
      VisitorName: row.visitorName,
      VisitorId: row.checkInId,
      VisitorMobile: row.visitorMobile,
      nationality: row.nationality,
      VisitorCompany: row.visitorCompany,
      EmployeeName: row.host,
      visitDateTime: formatDateTimeForExcel(row.visitDate),
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'BlackList Reports');

    // Adjust column widths for better alignment
    worksheet['!cols'] = [
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Mobile
      { wpx: 200 }, // Visitor Company
      { wpx: 150 }, // Employee Name
      { wpx: 200 }, // Check-In Date Time
    ];

    XLSX.writeFile(workbook, 'BlackList_Report.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text('Blacklist Report', 14, 16);
    doc.autoTable({
      head: [
        ['Photo', 'Visitor Name', 'VisitorId', 'Visitor Mobile', 'Nationality', 'Visitor Company', 'Employee Name', 'Visit Date Time']
      ],
      body: filteredData.map((row) => [
        '',
        row.visitorName,
        row.checkInId,
        row.visitorMobile,
        row.nationality,
        row.visitorCompany,
        row.host,
        formatDateTimeForExcel(row.visitDate),
      ]),
      startY: 30,
      theme: 'grid',
      theme: 'grid', didDrawCell: (data) => {
        // Ensure we only process body cells, not header or footers
        if (
          data.section === 'body' &&
          data.column.index === 0 &&
          filteredData[data.row.index]?.visitorPhoto
        ) {
          try {
            // Clean base64 string if it already includes the data URI prefix
            let base64 = filteredData[data.row.index].visitorPhoto;
            base64 = base64.replace(/^data:image\/(png|jpeg);base64,/, '');

            const img = `data:image/png;base64,${base64}`;

            const cellWidth = data.cell.width;
            const cellHeight = data.cell.height;
            const imgSize = Math.min(cellWidth, cellHeight) - 2;
            const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
            const yOffset = data.cell.y + (cellHeight - imgSize) / 2;

            doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
          } catch (err) {
            console.error('Error adding image:', err);
          }
        }
      },
    });
    doc.save('BlackList_Report.pdf');
  };

  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };


  return (
    <Container>
      <Header>
        <Heading>Black List Report</Heading>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SearchBox>
            <SearchIcon size={20} />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </SearchBox>
          <DropdownContainerTwo>
            <ExportIcon onClick={togglePanel} title="Export">
              <FiDownload size={25} />
            </ExportIcon>
            {/* Show the panel with options if isPanelOpen is true */}
            {isPanelOpen && (
              <OptionsPanel>
                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
              </OptionsPanel>
            )}
          </DropdownContainerTwo>
        </div>


      </Header>
      <Card>
        <DropdownContainer ref={dropdownRef}>
          <Label>Report Type</Label>
          <Dropdown onClick={toggleDropdown}>
            <DropdownText>{selectedOption || 'Select Type'}</DropdownText>
            <DropdownIcon size={20} />
          </Dropdown>
          {isOpen && (
            <DropdownPanel>
              {['Date Wise', 'Company Wise'].map((option) => (
                <DropdownOption key={option} onClick={() => handleOptionClick(option)}>
                  {option}
                </DropdownOption>
              ))}
            </DropdownPanel>
          )}
        </DropdownContainer>
        {selectedOption === 'Date Wise' && (
          <DateContainer>
            <DateInputContainer>
              <Label>From Date</Label>
              <StyledDatePicker
                selected={fromDate}
                onChange={(date) => setFromDate(date)}
                maxDate={new Date()}
                dateFormat="dd-MM-yyyy"
              />
            </DateInputContainer>
            <DateInputContainer>
              <Label>To Date</Label>
              <StyledDatePicker
                selected={toDate}
                onChange={(date) => setToDate(date)}
                dateFormat="dd-MM-yyyy"
                minDate={fromDate}
                maxDate={new Date()}
              />
            </DateInputContainer>
          </DateContainer>
        )}
        {selectedOption === 'Company Wise' && (
          <CompanyInputContainer>
            <Label>Company Name</Label>
            <CompanyInput
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Enter company name"
            />
          </CompanyInputContainer>
        )}
        <ButtonGroup>

          <Button onClick={() => {
            setFromDate(null);
            setToDate(null);
            setCompanyName('');
            setSelectedOption('');
            setIsSearchClicked(false);
            setFilterInfo({ type: "", value: "" });
            setTableData([]);
            setTableData([...originalTableData]);
            fetchVisitorTypeData();
            setCurrentPage(1); // Reset pagination to the first page
            setSearchQuery('');
          }}>Reset</Button>
          <Button onClick={handleSearchData}>Search</Button>
        </ButtonGroup>
      </Card>

      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <TableHeader colSpan={'8'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>BlackList Report </span>
                  <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                    {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                  </IconWrapper>
                </div>
              </TableHeader>

            </tr>
          </thead>
          {isExpanded && (
            <>
              <thead>
                <tr>
                  <TableHeader>Photo</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name {sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('checkInId')}>Visitor Id {sortColumn === 'checkInId' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorMobile')}>Visitor Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('nationality')}>Nationality{sortColumn === 'nationality' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorCompany')}>Visitor Company{sortColumn === 'visitorCompany' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('host')}>Employee Name{sortColumn === 'host' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitDate')}>Visit Date Time{sortColumn === 'visitDate' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                </tr>
              </thead>
              <tbody>
                {currentRows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Circle> {row.visitorPhoto ? (
                        <img
                          src={`data:image/png;base64,${row.visitorPhoto}`}
                          alt="Profile"
                          style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                        />
                      ) : (
                        <ProfileIcon>
                          <User size={15} />
                        </ProfileIcon>
                      )}
                      </Circle>
                    </TableCell>
                    <TableCell>{row.visitorName}</TableCell>
                    <TableCell>{row.checkInId}</TableCell>
                    <TableCell>{row.visitorMobile}</TableCell>
                    <TableCell>{row.nationality}</TableCell>
                    <TableCell>{row.visitorCompany}</TableCell>
                    <TableCell>{row.host}</TableCell>
                    <TableCell>
                      {row.visitDate}
                    </TableCell>
                  </TableRow>
                ))}
              </tbody>
            </>)}

        </StyledTable>
        {filteredData.length === 0 && <ZeroStateMessage>No data available</ZeroStateMessage>}
        {isExpanded && (
          <>
            <PaginationContainer>
              <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </PaginationButton>

              <DropdownSelect value={currentPage} onChange={handlePageChange}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Page {i + 1}
                  </option>
                ))}
              </DropdownSelect>

              <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </>)}
      </TableContainer>
      <ToastContainer />

    </Container>
  );
};

export default BlackListReportPage;
